import axios from "axios";

const tratarCodigoLido = async (
  codigo,
  {
    carrinhos,
    setCarrinhos,
    setAlertaCarrinho,
    setAlertaCarrinhoDesconhecido,
    setMensagemScanner,
    setCodigoLidoDesconhecido
  }
) => {
  const corrigido = codigo
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toUpperCase();

     // 🔧 Padronização do código: remove zeros após prefixo
  corrigido = corrigido
    .replace(/^CAR0+(\d+)$/, "CAR$1")
.replace(/^B0+(\d+)$/, "B$1");

  if (!corrigido) return;

  const jaExiste = carrinhos.some((c) => c.codigo === corrigido);
  if (jaExiste) {
    setAlertaCarrinho(true);
    return;
  }

  try {
    const valida = await axios.get(
      `${process.env.REACT_APP_API}/verificar-carrinho?codigo=${corrigido}`
    );

    if (!valida.data.valido) {
      setCodigoLidoDesconhecido(corrigido);
      setAlertaCarrinhoDesconhecido(true);
      return;
    }

    const resposta = await axios.get(
      `${process.env.REACT_APP_API}/tempo-posse?codigo=${corrigido}`
    );
    const tempoPosse = resposta.data.tempo_posse ?? null;

    setCarrinhos((prev) => [
      ...prev,
      { codigo: corrigido, tempo_posse: tempoPosse }
    ]);

    // ✅ Mostrar mensagem de sucesso temporária
    setMensagemScanner(true);
    setTimeout(() => {
      setMensagemScanner(false);
    }, 2000);

  } catch (error) {
    console.error("Erro na leitura:", error);
  }
};

export default tratarCodigoLido;
